import React from "react"
import { InputGroup, Input, InputGroupText, Spinner } from "reactstrap"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faSearch } from "@fortawesome/free-solid-svg-icons"

const SearchInputWithLoader = ({
  value,
  onChange,
  loading,
  placeholder = "Search...",
}) => {
  return (
    <InputGroup
      style={{ marginBottom: "16px", boxShadow: "0 1px 4px rgba(0,0,0,0.08)" }}
    >
      <Input
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder={placeholder}
        style={{
          fontSize: "14px",
          borderRadius: "6px 0 0 6px",
          border: "1px solid #e36f1e",
          padding: "10px 12px",
        }}
      />
      <InputGroupText
        style={{
          backgroundColor: "#e36f1e",
          color: "#fff",
          borderRadius: "0 6px 6px 0",
          padding: "10px 14px",
          minWidth: "45px",
        }}
      >
        {loading ? (
          <Spinner size="sm" color="light" />
        ) : (
          <FontAwesomeIcon icon={faSearch} />
        )}
      </InputGroupText>
    </InputGroup>
  )
}

export default SearchInputWithLoader
